/**
 * Normalize options to always be { label, value }[].
 * @param {Array} options - Raw options (array of objects or primitives)
 * @returns {Array<{label: *, value: *}>}
 */
export function normalizeOptions(options) {
  if (!Array.isArray(options)) return [];
  return typeof options[0] === "object"
    ? options
    : options.map((item) => ({ label: item, value: item }));
}

/**
 * Filter options by search query (case-insensitive label match).
 * @param {Array<{label: string, value: *}>} options - Normalized options
 * @param {string} searchQuery - Search string
 * @returns {Array<{label: string, value: *}>}
 */
export function filterOptionsBySearch(options, searchQuery) {
  if (!searchQuery || !searchQuery.trim()) return options;
  const q = searchQuery.toLowerCase();
  return options.filter((opt) =>
    String(opt.label).toLowerCase().includes(q)
  );
}
